import { render, staticRenderFns } from "./PermissionsGlobal.vue?vue&type=template&id=5cdfd71c&"
import script from "./PermissionsGlobal.vue?vue&type=script&lang=js&"
export * from "./PermissionsGlobal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports